export const convertBase64toPDF = (base64String: string): Blob => {
  const binaryString = atob(base64String);
  const binaryData = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    binaryData[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([binaryData], { type: 'application/pdf' });
  return blob;
};

export const openPrinterWithUrl = (url: string, id: string): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    let iframeNode = document.getElementById(id) as HTMLIFrameElement;
    if (url) {
      if (!iframeNode) {
        iframeNode = document.createElement('iframe');
        iframeNode.id = id;
        iframeNode.style.display = 'none';
        document.body.appendChild(iframeNode);
      }
      iframeNode.src = url;
      iframeNode.onload = () => {
        try {
          if (iframeNode.contentWindow) {
            const printWindow = iframeNode.contentWindow;
            printWindow.onafterprint = () => {
              iframeNode.remove();
            };
            printWindow.print();
            resolve(true);
          } else {
            iframeNode.remove();
            reject(false);
          }
        } catch {
          iframeNode.remove();
          reject(false);
        }
      };
      iframeNode.onerror = () => {
        iframeNode.remove();
        reject(false);
      };
    } else {
      reject(reject);
    }
  });
};
